import React, { useState, useCallback, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Register from './components/Register';
import './App.css';

const AUTH_TOKEN_KEY = 'token';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() =>
    Boolean(localStorage.getItem(AUTH_TOKEN_KEY))
  );
  const [showRegister, setShowRegister] = useState(false);

  const checkAuth = useCallback(() => {
    setIsAuthenticated(Boolean(localStorage.getItem(AUTH_TOKEN_KEY)));
  }, []);

  useEffect(() => {
    // Re-check auth when storage changes (e.g. another tab logged out)
    const handleStorage = () => checkAuth();
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [checkAuth]);

  const handleLogout = useCallback(() => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    checkAuth();
  }, [checkAuth]);

  if (!isAuthenticated) {
    if (showRegister) {
      return (
        <Register onGoToLogin={() => setShowRegister(false)} />
      );
    }
    return (
      <Login
        onSuccess={checkAuth}
        onGoToRegister={() => setShowRegister(true)}
      />
    );
  }

  return <Dashboard onLogout={handleLogout} />;
}

export default App;